import React from 'react'
import {Body1, Body1PointerLink, ConfirmedText, Subhead3} from "../../../components/Font";
import {AddInfo, AddInfoContent, UserDataContent,} from "../../../components/ui/Content";
import {useAppSelector} from "../../../app/hooks";
import {useTheme} from 'styled-components';

interface ISocialNumberProps {
    goToEditSocialNumber: () => void
    openModalInfo: () => void
}

export const SocialNumberInfo = ({goToEditSocialNumber, openModalInfo}: ISocialNumberProps) => {
    const {socialNumber, passport, foreign_passport} = useAppSelector(state => state.account)
    const Theme = useTheme()

    return (
        <AddInfo
            height={!foreign_passport && !passport && !socialNumber ? '110px' : '160px'}
            background={socialNumber ? Theme.color.primaryBackground : ''}
            cursor={socialNumber?.is_verified ? 'pointer' : 'default'}
            onClick={() => {
                if (socialNumber?.is_verified) {
                    openModalInfo()
                }
            }}>
            <Subhead3>
                СНИЛС
            </Subhead3>

            {!socialNumber ?
                <Body1PointerLink onClick={goToEditSocialNumber}>
                    Добавить
                </Body1PointerLink> :
                <>
                    {!socialNumber?.is_verified &&
                        <UserDataContent>
                            <Body1>{socialNumber?.value}</Body1>
                            <Body1PointerLink
                                onClick={goToEditSocialNumber}>
                                Изменить
                            </Body1PointerLink>
                        </UserDataContent>
                    }</>
            }

            {socialNumber?.is_verified &&
                <AddInfoContent>
                    <Body1>{socialNumber?.value}</Body1>
                    <ConfirmedText> Документ подтвержден </ConfirmedText>
                </AddInfoContent>}

        </AddInfo>
    )
}